import React from 'react';

export const context = {
    finn: {
        whitelabel: 'finn',
        language: 'NO',
        currency: 'NOK',
        hotelBaseUrl: 'https://hotell.finn.no',
        disableCo2: true,
        disableSavedSearch: false,
        disableResultListWidget: false,
        disableVerticals: false,
        disableEasyAdPanel: false,
        disableCmsPanel: false,
        disablePrepackage: false,
        theme: {
            buttonBackgroundColor: '',
            expansionPanelBackgroundColor: '',
            activeIconColor: '#06befb',
            inactiveIconColor: '#767676',
        },
        path: {
            flight: '/reise/flybilletter',
            frontpage: '/reise',
        },
    },
    blocket: {
        whitelabel: 'blocket',
        language: 'SV',
        currency: 'SEK',
        hotelBaseUrl: 'https://hotell.blocket.se',
        disableCo2: false,
        disableSavedSearch: true,
        disableResultListWidget: true,
        disableVerticals: true,
        disableEasyAdPanel: false,
        disableCmsPanel: false,
        disablePrepackage: true,
        theme: {
            buttonBackgroundColor: '#49B975',
            expansionPanelBackgroundColor: '#f9f7f6',
            activeIconColor: '#4182c3',
            inactiveIconColor: '#9A9999',
        },
        path: {
            flight: '/flyg',
            frontpage: '',
        },
    },
};

export default React.createContext(context.finn);
